import * as THREE from 'three'

import Config from '@glass-designer/config'
import BaseObject from './baseObject'
import MathsUtils from '@/utils/mathsUtils'
import GlassDesignerTypes from '../types'


// Editing Point
// A point object in the scene to display a point (like add points to a segment) with datum links used for dimensioning
export default class EditingPoint extends BaseObject {
  constructor(editor, options = {}) {
    super(editor)

    this.position = new THREE.Vector2(0, 0)

    // Datum links used while editing
    // Used to update the dynamic dimensions while adding/moving the point
    this.datumLinks = []
  }

  // onBeforeRender
  // Called prior to rendering of the object
  onBeforeRender() {
    super.onBeforeRender()

  }


  // Update the position of the cutout
  setPosition(pos) {
    this.position.set(pos.x, pos.y)
  }

  // Set the datum links
  setDatumLinks(links) {
    this.datumLinks = links
  }


}
